import React from 'react';
import type { PaymentlineView } from 'shared-models/browser';
import { Button } from '../../../../../components/Button';
import { useCibusFinishOrder } from './useCibusFinishOrder';

type CibusFinishOrderButtonProps = {
  tenantId: string;
  employeeSession: string | null;
  paymentline: PaymentlineView;
  isManager: boolean;
};

// Cibus approved the deal but the line never settled locally: a manager closes it without Pluxee.
export const CibusFinishOrderButton: React.FC<CibusFinishOrderButtonProps> = ({ tenantId, employeeSession, paymentline, isManager }) => {
  const { isFinishing, finish } = useCibusFinishOrder({ tenantId, employeeSession, paymentlineId: paymentline.id });

  if (!isManager || paymentline.status !== 'new' || !paymentline.cibusOrderId) {
    return null;
  }

  return (
    <Button variant="confirm" fullWidth onClick={finish} loading={isFinishing} dataTestId={`cibus-finish-order-${paymentline.id}`}>
      {paymentline.amount < 0 ? 'סיים החזר' : 'סיים הזמנה'}
    </Button>
  );
};
